<template>
  <div class="content">
    <h1>{{serviceLabel}}</h1>

    <router-view/>
  </div>
</template>

<script>
import store from '@/store'
import actions from '@/actions'

export default {
  name: 'Signup',

  data: () => ({
    store,
  }),

  computed: {
    serviceKey() {
      return this.store.state.signupType.key
    },
    serviceLabel() {
      return this.store.state.signupType.label
    },
    steps() {
      return this.store.state.signupSteps[this.serviceKey]
    },
  },

  methods: {
    canNavigate(step) {
      return this.store.getPreviousStep(this.serviceKey, step.routeName)
        .isComplete(this.store.state)
    },

    goto(step) {
      if (this.canNavigate(step)) {
        this.$router.push({ name: step.routeName })
      }
    },

    isComplete(step) {
      return step.isComplete(this.store.state)
    },
  },

  async mounted() {
    const { code } = this.$route.query
    if (code) {
      await actions.getSignup(String(code))
      const firstStep = this.steps[0]
      this.$router.push({ name: firstStep.routeName })
    }

    if (!code && !this.serviceKey) {
      this.$router.push({ name: 'Services' })
    }
  },
};
</script>

<style lang="scss">
</style>

<style scoped lang="scss">
</style>
